import { ChatUserNameProps } from './types';

export const ChatUserName = ({ username }: ChatUserNameProps) => (
    <span className="font-medium" data-testid="userName">
        {username}
    </span>
);
